module.exports = __webpack_public_path__ + "img/angel.239a2f02.png";